import { FC } from "react";

interface TrustItem {
  icon: string;
  title: string;
  desc: string;
}

const trustItems: TrustItem[] = [
  { icon: "👥", title: "People trust us", desc: "Over a thousand users have used our service to simplify their work with digital documents." },
  { icon: "🏢", title: "Businesses trust us", desc: "One of the highest-rated PDF software" },
  // { icon: "🔌", title: "Our partners trust us", desc: "Integrates with Chrome, Google Workspace, and Dropbox — all free to use." },
  { icon: "🛡️", title: "Secure & private", desc: "Files auto-deleted after 1 hour. SSL-encrypted transfers. GDPR compliant." },
];

const TrustSection: FC = () => {
  return (
    <div style={{ background: "#f8fafc", padding: "56px 40px", textAlign: "center" }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Why choose EasyPDF?</h2>
      <p style={{ fontSize: 15, color: "#888", marginBottom: 40 }}>Trusted by individuals and businesses worldwide.</p>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
        gap: 16,
      }}>
        {trustItems.map((item, i) => (
          <div key={i}
            style={{
              background: "#fff", border: "1px solid #f0ede8",
              borderRadius: 16, padding: "28px 22px", textAlign: "left",
              transition: "box-shadow 0.18s",
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.07)"}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = "none"}>
            <div style={{ fontSize: 32, marginBottom: 14 }}>{item.icon}</div>
            <h4 style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>{item.title}</h4>
            <p style={{ fontSize: 13, color: "#888", lineHeight: 1.65 }}>{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Stats bar */}
      <div style={{
        display: "flex", gap: 40, justifyContent: "center", flexWrap: "wrap",
        marginTop: 48, paddingTop: 40, borderTop: "1px solid #e5e7eb",
      }}>
        {/*{[*/}
        {/*  { stat: "1B+", label: "Users worldwide" },*/}
        {/*  { stat: "30+", label: "PDF tools" },*/}
        {/*  { stat: "4.9★", label: "Average rating" },*/}
        {/*  { stat: "250M+", label: "Documents processed/month" },*/}
        {/*].map((s, i) => (*/}
        {/*  <div key={i} style={{ textAlign: "center" }}>*/}
        {/*    <div style={{ fontSize: 30, fontWeight: 700, color: "#2563eb" }}>{s.stat}</div>*/}
        {/*    <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>{s.label}</div>*/}
        {/*  </div>*/}
        {/*))}*/}
      </div>
    </div>
  );
};

export default TrustSection;

